// removed by extract-text-webpack-plugin
module.exports = {"switch":"Switch-m__switch___3WO3b","switch_input":"Switch-m__switch_input___1p3zz","switchInput":"Switch-m__switch_input___1p3zz","switch_wrap":"Switch-m__switch_wrap___3HO_4","switchWrap":"Switch-m__switch_wrap___3HO_4","switch_container":"Switch-m__switch_container___2krtG","switchContainer":"Switch-m__switch_container___2krtG","switch_circle":"Switch-m__switch_circle___1PgfU","switchCircle":"Switch-m__switch_circle___1PgfU","switch_text":"Switch-m__switch_text___2JyIn","switchText":"Switch-m__switch_text___2JyIn"};


//////////////////
// WEBPACK FOOTER
// ./components/switch/Switch.m.sass
// module id = GISy
// module chunks = 0